// PWA service worker registration is disabled; this module exists to
// proactively unregister any service worker left over from a prior install.

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
